import { render, staticRenderFns } from "./MapBrandModal.vue?vue&type=template&id=0948b7c6&lang=html&"
import script from "./MapBrandModal.vue?vue&type=script&lang=js&"
export * from "./MapBrandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports